<template>
	<div>
		<Card>
			
			<Form ref="searchForm" :model="searchForm" inline :label-width="80">
				<FormItem :label="$t('SplitDetail.OrderNo')">
					<Input v-model="searchForm.orderNo" :placeholder="$t('SplitDetail.OrderNoPlaceholder')" style="width: 200px" clearable />
				</FormItem>
				<FormItem :label="$t('SplitRule.Station')">
					<Select v-model="searchForm.stationId" :placeholder="$t('SplitRule.SelectStation')" style="width: 200px" clearable>
						<Option v-for="item in stationList" :key="item.StationId" :value="item.StationId">
							{{ item.StationName || '-' }}
						</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('SplitDetail.SplitType')">
					<Select v-model="searchForm.splitType" :placeholder="$t('SplitDetail.SelectSplitType')" style="width: 150px" clearable>
						<Option :value="1">{{ $t('SplitDetail.PlatformSplit') }}</Option>
						<Option :value="2">{{ $t('SplitDetail.StationSplit') }}</Option>
					</Select>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSearch">{{ $t('Common.Search') }}</Button>
					<Button type="default" @click="handleReset" style="margin-left: 8px;">{{ $t('Common.Reset') }}</Button>
				</FormItem>
			</Form>
		</Card>

		<Card>
			<Table border :columns="columns" :data="tableData" :loading="tableLoading">
				<template #splitType="{ row }">
					<Tag :color="row.SplitType === 1 ? 'primary' : 'success'">
						{{ row.SplitType === 1 ? $t('SplitDetail.PlatformSplit') : $t('SplitDetail.StationSplit') }}
					</Tag>
				</template>
				<template #splitStatus="{ row }">
					<Tag :color="row.SplitStatus === 1 ? 'success' : 'default'">
						{{ row.SplitStatus === 1 ? $t('SplitDetail.SplitSuccess') : $t('SplitDetail.SplitPending') }}
					</Tag>
				</template>
				<template #splitAmount="{ row }">
					<span style="color: #52c41a; font-weight: bold;">
						¥{{ formatMoney(row.SplitAmount) }}
					</span>
				</template>
				<template #createTime="{ row }">
					{{ formatDateTime(row.CreateTime) }}
				</template>
			</Table>
			<div style="margin-top: 16px; text-align: right;">
				<Page
					:total="pagination.total"
					:current="pagination.current"
					:page-size="pagination.pageSize"
					:page-size-opts="[10, 20, 50, 100]"
					show-total
					show-sizer
					@on-change="handlePageChange"
					@on-page-size-change="handlePageSizeChange"
				/>
			</div>
		</Card>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import webapi from '../../../webapi';

	export default {
		name: 'SplitDetail',
		data() {
			return {
				searchForm: {
					orderNo: '',
					stationId: undefined,
					splitType: undefined,
					splitStatus: undefined
				},
				columns: [],
				tableData: [],
				tableLoading: false,
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				stationList: []
			};
		},
		computed: {
			...mapState({
				Stations: 'Stations'
			})
		},
		watch: {
			// 监听语言变化，重新初始化列定义
			'$i18n.locale'() {
				this.initColumns();
			}
		},
		created() {
			this.initColumns();
			this.getStationList();
			this.getSplitDetailList();
		},
		methods: {
			// 初始化表格列
			initColumns() {
				this.columns = [
					{
						title: this.$t('SplitRule.Index'),
						type: 'index',
						width: 80,
						align: 'center'
					},
					{
						title: this.$t('SplitDetail.OrderNo'),
						key: 'OrderNo',
						minWidth: 200,
						fixed: 'left'
					},
					{
						title: this.$t('SplitRule.Operator'),
						key: 'OperatorName',
						minWidth: 150
					},
					{
						title: this.$t('SplitRule.StationName'),
						key: 'StationName',
						minWidth: 200
					},
					{
						title: this.$t('SplitDetail.SplitType'),
						slot: 'splitType',
						width: 120,
						align: 'center'
					},
					{
						title: this.$t('SplitDetail.SplitAmount'),
						slot: 'splitAmount',
						width: 150,
						align: 'right'
					},
					{
						title: this.$t('SplitDetail.SplitStatus'),
						slot: 'splitStatus',
						width: 120,
						align: 'center'
					},
					{
						title: this.$t('SplitDetail.CreateTime'),
						slot: 'createTime',
						width: 180,
						align: 'center'
					}
				];
			},

			// 获取场站列表
			async getStationList() {
				try {
					const res = await this.$axios.post(webapi.base_api_url + '/Home/GetCurrentUserStations', {});
					if (res.status === 200 && res.data.Code === 0) {
						this.stationList = res.data.Data.List || [];
						console.log('场站列表数据:', this.stationList);
					}
				} catch (error) {
					console.error('获取场站列表失败:', error);
					this.$Message.error(this.$t('SplitRule.GetStationListFail'));
				}
			},

			// 获取分账明细列表
			async getSplitDetailList() {
				this.tableLoading = true;
				try {
					const params = {
						orderNo: this.searchForm.orderNo,
						stationId: this.searchForm.stationId,
						splitType: this.searchForm.splitType,
						splitStatus: this.searchForm.splitStatus,
						pageIndex: this.pagination.current,
						pageSize: this.pagination.pageSize
					};

					const res = await this.$axios.post(webapi.base_api_url + '/Split/GetSplitDetails', params);

					if (res.status === 200 && res.data.Code === 0) {
						this.tableData = res.data.Data.List || [];
						this.pagination.total = res.data.Total || 0;
					} else {
						this.$Message.error(res.data.Message || this.$t('SplitDetail.GetSplitDetailListFail'));
					}
				} catch (error) {
					console.error('获取分账明细列表失败:', error);
					this.$Message.error(this.$t('SplitDetail.GetSplitDetailListFail'));
				} finally {
					this.tableLoading = false;
				}
			},

			// 搜索
			handleSearch() {
				this.pagination.current = 1;
				this.getSplitDetailList();
			},

			// 重置
			handleReset() {
				this.searchForm = {
					orderNo: '',
					stationId: undefined,
					splitType: undefined,
					splitStatus: undefined
				};
				this.pagination.current = 1;
				this.getSplitDetailList();
			},

			// 分页变化
			handlePageChange(page) {
				this.pagination.current = page;
				this.getSplitDetailList();
			},

			// 每页条数变化
			handlePageSizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.current = 1;
				this.getSplitDetailList();
			},

			// 格式化金额
			formatMoney(amount) {
				if (amount === null || amount === undefined) return '0.00';
				return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},

			// 格式化日期时间
			formatDateTime(dateTime) {
				if (!dateTime) return '-';
				const date = new Date(dateTime);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			}
		}
	};
</script>

<style scoped>
	:deep(.ivu-form-item) {
		margin-bottom: 16px;
	}
</style>
